import { message } from 'antd'
import {
  LIST_STATION_SUMMARY_REQUEST,
  LIST_STATION_SUMMARY_SUCCESS,
  LIST_STATION_SUMMARY_FAIL,
  LIST_CHECKIN_SAMPLE_REQUEST,
  LIST_CHECKIN_SAMPLE_SUCCESS,
  LIST_CHECKIN_SAMPLE_FAIL,
  EXPORT_CHECKIN_SUCCESS,
  EXPORT_CHECKIN_FAIL,
  EXPORT_CHECKIN_REQUEST,
  DELETE_CHECKIN_REQUEST,
  DELETE_CHECKIN_SUCCESS,
  DELETE_CHECKIN_FAIL,
  CLEAR_MESSAGE,
  GET_DATA_CHECKIN_REQUEST,
  GET_DATA_CHECKIN_SUCCESS,
  GET_DATA_CHECKIN_FAIL,
  CALL_PATIENT_CHECKIN_REQUEST,
  CALL_PATIENT_CHECKIN_SUCCESS,
  CALL_PATIENT_CHECKIN_FAIL,
  SUBMIT_CHECKIN_REQUEST,
  SUBMIT_CHECKIN_SUCCESS,
  SUBMIT_CHECKIN_FAIL,
  SAVE_PRESCRIPTION_REQUEST,
  SAVE_PRESCRIPTION_SUCCESS,
  SAVE_PRESCRIPTION_FAIL,
  DELETE_PRESCRIPTION_REQUEST,
  DELETE_PRESCRIPTION_SUCCESS,
  DELETE_PRESCRIPTION_FAIL,
  GET_DATA_SPECIMENS_REQUEST,
  GET_DATA_SPECIMENS_SUCCESS,
  GET_DATA_SPECIMENS_FAIL,
  LOADING_SPECIMENS_REQUEST,
  LOADING_SPECIMENS_SUCCESS,
  LOADING_SPECIMENS_FAIL,
  GET_SUMMARY_PENDING_NOTCHECK_REQUEST,
  GET_SUMMARY_PENDING_NOTCHECK_SUCCESS,
  GET_SUMMARY_PENDING_NOTCHECK_FAIL,
  CLEAR_DATA_CHECKIN,
  GET_DATA_CHECKIN_NOLOADING_REQUEST,
  GET_DATA_CHECKIN_NOLOADING_SUCCESS,
  GET_DATA_CHECKIN_NOLOADING_FAIL,
  GET_ALL_MEDICAL_INFO_REQUEST,
  GET_ALL_MEDICAL_INFO_SUCCESS,
  GET_ALL_MEDICAL_INFO_FAIL,
  GET_LIST_EXPORT_REQUEST,
  GET_LIST_EXPORT_SUCCESS,
  GET_LIST_EXPORT_FAIL,
  DOWNLOAD_CHECKIN_REQUEST,
  DOWNLOAD_CHECKIN_SUCCESS,
  DOWNLOAD_CHECKIN_FAIL,
  GET_LIST_RAPT_CPPT_REQUEST,
  GET_LIST_RAPT_CPPT_SUCCESS,
  GET_LIST_RAPT_CPPT_FAIL,
  GET_DETAIL_RAPT_CPPT_REQUEST,
  GET_DETAIL_RAPT_CPPT_SUCCESS,
  GET_DETAIL_RAPT_CPPT_FAIL,
  POST_RAPT_CPPT_REQUEST,
  POST_RAPT_CPPT_SUCCESS,
  POST_RAPT_CPPT_FAIL,
  GET_MEDICAL_DATA_SUMMARIES_REQUEST,
  GET_MEDICAL_DATA_SUMMARIES_SUCCESS,
  GET_MEDICAL_DATA_SUMMARIES_FAIL,
  PATCH_RAPT_CPPT_REQUEST,
  PATCH_RAPT_CPPT_SUCCESS,
  PATCH_RAPT_CPPT_FAIL,
  DELETE_RAPT_CPPT_REQUEST,
  DELETE_RAPT_CPPT_SUCCESS,
  DELETE_RAPT_CPPT_FAIL,
  VERIFY_RAPT_CPPT_REQUEST,
  VERIFY_RAPT_CPPT_SUCCESS,
  VERIFY_RAPT_CPPT_FAIL,
  DUPLICATE_RAPT_CPPT_REQUEST,
  DUPLICATE_RAPT_CPPT_SUCCESS,
  DUPLICATE_RAPT_CPPT_FAIL,
  GET_HISTORY_RAPT_CPPT_REQUEST,
  GET_HISTORY_RAPT_CPPT_SUCCESS,
  GET_HISTORY_RAPT_CPPT_FAIL,
  GET_MEDICAL_DIAGNOSIS_SUMMARIES_REQUEST,
  GET_MEDICAL_DIAGNOSIS_SUMMARIES_SUCCESS,
  GET_MEDICAL_DIAGNOSIS_SUMMARIES_FAIL,
  GET_LIST_MEDICAL_PROCEDURE_REQUEST,
  GET_LIST_MEDICAL_PROCEDURE_SUCCESS,
  GET_LIST_MEDICAL_PROCEDURE_FAIL,
  GET_MEDICAL_DOCUMENT_SICK_LETTER_REQUEST,
  GET_MEDICAL_DOCUMENT_SICK_LETTER_SUCCESS,
  GET_MEDICAL_DOCUMENT_SICK_LETTER_FAIL,
  GET_LIST_MEDICAL_LETTER_REQUEST,
  GET_LIST_MEDICAL_LETTER_SUCCESS,
  GET_LIST_MEDICAL_LETTER_FAIL,
  GET_DETAIL_MEDICAL_LETTER_REQUEST,
  GET_DETAIL_MEDICAL_LETTER_SUCCESS,
  GET_DETAIL_MEDICAL_LETTER_FAIL,
  GET_PATIENT_DATA_MEDICAL_LETTER_REQUEST,
  GET_PATIENT_DATA_MEDICAL_LETTER_SUCCESS,
  GET_PATIENT_DATA_MEDICAL_LETTER_FAIL,
  SAVE_MEDICAL_LETTER_REQUEST,
  SAVE_MEDICAL_LETTER_SUCCESS,
  SAVE_MEDICAL_LETTER_FAIL,
  DELETE_MEDICAL_LETTER_REQUEST,
  DELETE_MEDICAL_LETTER_SUCCESS,
  DELETE_MEDICAL_LETTER_FAIL,

  GET_LIST_MEDICAL_SUPPLIES_REQUEST,
  GET_LIST_MEDICAL_SUPPLIES_SUCCESS,
  GET_LIST_MEDICAL_SUPPLIES_FAIL,
  GET_DETAIL_MEDICAL_SUPPLIES_REQUEST,
  GET_DETAIL_MEDICAL_SUPPLIES_SUCCESS,
  GET_DETAIL_MEDICAL_SUPPLIES_FAIL,
  POST_MEDICAL_SUPPLIES_REQUEST,
  POST_MEDICAL_SUPPLIES_SUCCESS,
  POST_MEDICAL_SUPPLIES_FAIL,
  PATCH_MEDICAL_SUPPLIES_REQUEST,
  PATCH_MEDICAL_SUPPLIES_SUCCESS,
  PATCH_MEDICAL_SUPPLIES_FAIL,
  DELETE_MEDICAL_SUPPLIES_REQUEST,
  DELETE_MEDICAL_SUPPLIES_SUCCESS,
  DELETE_MEDICAL_SUPPLIES_FAIL
} from '../../constants/stations'

const initialState = {
  checkinSampleData: [],
  specimenData: [],
  stationSummaries: [],
  pendingNotCheckSummaries: [],
  dataCheckin: {},
  dataAllMedicalInfo: [],
  listExport: [],
  listRescription: [],
  listMedicalProcedure: [],
  listMedicalLetter: [],
  listMedicalSupplies: [],
  pageable: {
    page: 1,
    size: 10,
    hits: 1
  },
  pageablePrescription: {
    page: 1,
    size: 10,
    hits: 1,
    total: 1
  },
  pageableMedicalProcedure: {
    page: 1,
    size: 10,
    hits: 1,
    total: 1
  },
  pageableMedicalLetter: {
    page: 1,
    size: 10,
    hits: 1,
    total: 1
  },
  pageableMedicalSupplies: {
    page: 1,
    size: 10,
    hits: 1,
    total: 1
  },
  medicalDocumentSickLetter: null,
  medicalLetterDetail: null,
  loadingAllMedInfo: false,
  loadingStation: false,
  loadingSubmit: false,
  loadingExport: false,
  loadingDownload: false,
  loadingDelete: false,
  loadingOnCheck: false,
  loadingCall: false,
  loadingSpecimen: false,
  loadingSubmitNote: false,
  loadingDeleteNote: false,
  loadingListMedicalProcedure: false,
  loadingMedicalDocumentSickLetter: false,
  loadingListMedicalLetter: false,
  loadingDetailMedicalLetter: false,
  loadingMedicalLetterSubmit: false,
  loadingMedicalLetterDelete: false,
  loadingListMedicalSupplies: false,
  loadingDetailMedicalSupplies: false,
  loadingMedicalSuppliesSubmit: false,
  loadingMedicalSuppliesDelete: false,
  raptCpptList: [],
  loadingRaptCppt: false,
  raptCpptDetail: null,
  loadingRaptCpptDetail: false,
  loadingPostRaptCppt: false,
  medicalDataSummaries: null,
  loadingMedicalDataSummaries: false,
  loadingPatchRaptCppt: false,
  loadingDeleteRaptCppt: false,
  loadingVerifyRaptCppt: false,
  loadingDuplicateRaptCppt: false,
  raptCpptHistories: [],
  loadingRaptCpptHistories: false,
  medicalDiagnosisSummaries: [],
  loadingMedicalDiagnosisSummaries: false,
  loadingPrescriptionSubmit: false,
  loadingPrescriptionDelete: false,
  prescriptionSubmitError: null,
  error: '',
  message: null
}

const stationsReducer = (state = initialState, action) => {
  switch (action.type) {
    //get
    case LIST_STATION_SUMMARY_REQUEST:
      return { ...state, loadingStation: true, message: null }
    case LIST_STATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingStation: false,
        stationSummaries: action.payload
      }
    case LIST_STATION_SUMMARY_FAIL:
      return { ...state, loadingStation: false, error: action.payload }
    case GET_SUMMARY_PENDING_NOTCHECK_REQUEST:
      return { ...state, loadingStation: true, message: null }
    case GET_SUMMARY_PENDING_NOTCHECK_SUCCESS:
      return {
        ...state,
        loadingStation: false,
        pendingNotCheckSummaries: action.payload
      }
    case GET_SUMMARY_PENDING_NOTCHECK_FAIL:
      return { ...state, loadingStation: false, error: action.payload }
    case LIST_CHECKIN_SAMPLE_REQUEST:
      return {
        ...state,
        loadingStation: true
      }
    case LIST_CHECKIN_SAMPLE_SUCCESS:
      return {
        ...state,
        loadingStation: false,
        checkinSampleData: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_CHECKIN_SAMPLE_FAIL:
      return {
        ...state,
        loadingStation: false,
        error: action.payload,
        checkinSampleData: []
      }
    case GET_DATA_CHECKIN_REQUEST:
      return {
        ...state,
        loadingOnCheck: true,
        error: null,
        message: null
      }
    case GET_DATA_CHECKIN_SUCCESS:
      return {
        ...state,
        loadingOnCheck: false,
        dataCheckin: action.payload,
        message: `${action.payload?.patient?.name}-${action.payload?.patient?.registrationProductNumber}`,
        error: null
      }
    case GET_DATA_CHECKIN_FAIL:
      return {
        ...state,
        loadingOnCheck: false,
        dataCheckin: {},
        message: 'The patient data was not found',
        error: action.payload
      }
    case GET_DATA_CHECKIN_NOLOADING_REQUEST:
      return {
        ...state,
        loadingSubmit: true
      }
    case GET_DATA_CHECKIN_NOLOADING_SUCCESS:
      return {
        ...state,
        loadingSubmit: false,
        dataCheckin: action.payload
      }
    case GET_DATA_CHECKIN_NOLOADING_FAIL:
      return {
        ...state,
        loadingSubmit: false
      }
    case GET_DATA_SPECIMENS_REQUEST:
      return {
        ...state,
        loadingSpecimen: true,
        error: null,
        message: null
      }
    case GET_DATA_SPECIMENS_SUCCESS:
      return {
        ...state,
        loadingSpecimen: false,
        specimenData: action.payload,
        error: null
      }
    case GET_DATA_SPECIMENS_FAIL:
      return {
        ...state,
        loadingSpecimen: false,
        specimenData: {},
        error: action.payload
      }
    case GET_LIST_EXPORT_REQUEST:
      return { ...state, loadingStation: true, message: null }
    case GET_LIST_EXPORT_SUCCESS:
      return {
        ...state,
        loadingStation: false,
        listExport: action.payload,
        pageable: action.pageable
      }
    case GET_LIST_EXPORT_FAIL:
      return {
        ...state,
        loadingStation: false,
        error: action.payload,
        listExport: []
      }
    case "GET_BASIC_MEDICAL_DATA_REQUEST":
      return { ...state, loadingDetailBasicMedicalData: true }
    case "GET_BASIC_MEDICAL_DATA_SUCCESS":
      return {
        ...state,
        loadingDetailBasicMedicalData: false
      }
    case "GET_BASIC_MEDICAL_DATA_FAIL":
      return {
        ...state,
        loadingDetailBasicMedicalData: false
      }
    case "GET_MEDICAL_RESUME_REQUEST":
      return { ...state, loadingDetailMedicalResume: true }
    case "GET_MEDICAL_RESUME_SUCCESS":
      return {
        ...state,
        loadingDetailMedicalResume: false
      }
    case "GET_MEDICAL_RESUME_FAIL":
      return {
        ...state,
        loadingDetailMedicalResume: false
      }

    //post
    case CALL_PATIENT_CHECKIN_REQUEST:
      return { ...state, loadingCall: true }
    case CALL_PATIENT_CHECKIN_SUCCESS:
      return {
        ...state,
        loadingCall: false
      }
    case CALL_PATIENT_CHECKIN_FAIL:
      return {
        ...state,
        loadingCall: false,
        error: action.payload,
        message: action.payload
      }
    case EXPORT_CHECKIN_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_CHECKIN_SUCCESS:
      return {
        ...state,
        loadingExport: false
      }
    case EXPORT_CHECKIN_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action.payload
      }
    case DOWNLOAD_CHECKIN_REQUEST:
      return {
        ...state,
        loadingDownload: true
      }
    case DOWNLOAD_CHECKIN_SUCCESS:
      return {
        ...state,
        loadingDownload: false
      }
    case DOWNLOAD_CHECKIN_FAIL:
      return {
        ...state,
        loadingDownload: false,
        error: action.payload
      }
    case SUBMIT_CHECKIN_REQUEST:
      return {
        ...state,
        loadingSubmit: true
      }
    case SUBMIT_CHECKIN_SUCCESS:
      return {
        ...state,
        loadingSubmit: false
      }
    case SUBMIT_CHECKIN_FAIL:
      return {
        ...state,
        loadingSubmit: false,
        message: action.payload,
        error: action.payload
      }
    case SAVE_PRESCRIPTION_REQUEST:
      return {
        ...state,
        loadingPrescriptionSubmit: true,
        prescriptionSubmitError: null
      }
    case SAVE_PRESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingPrescriptionSubmit: false
      }
    case SAVE_PRESCRIPTION_FAIL:
      return {
        ...state,
        loadingPrescriptionSubmit: false,
        prescriptionSubmitError: action.payload
      }
    case DELETE_PRESCRIPTION_REQUEST:
      return {
        ...state,
        loadingPrescriptionDelete: true
      }
    case DELETE_PRESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingPrescriptionDelete: false
      }
    case DELETE_PRESCRIPTION_FAIL:
      return {
        ...state,
        loadingPrescriptionDelete: false,
        error: action.payload
      }
    case LOADING_SPECIMENS_REQUEST:
      return {
        ...state,
        loadingSpecimen: true
      }
    case LOADING_SPECIMENS_SUCCESS:
      return {
        ...state,
        loadingSpecimen: false
      }
    case LOADING_SPECIMENS_FAIL:
      return {
        ...state,
        loadingSpecimen: false,
        error: action.payload
      }
    case 'ADD_CHECKIN_NOTE_REQUEST':
      return {
        ...state,
        loadingSubmitNote: true
      }
    case 'ADD_CHECKIN_NOTE_SUCCESS':
      return {
        ...state,
        loadingSubmitNote: false,
        dataCheckin: {
          ...state.dataCheckin,
          patient: {
            ...state.dataCheckin.patient,
            medicalInfoNote: action.payload
          }
        }
      }
    case 'ADD_CHECKIN_NOTE_FAIL':
      return {
        ...state,
        loadingSubmitNote: false,
        error: action.payload
      }

    //delete
    case DELETE_CHECKIN_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_CHECKIN_SUCCESS:
      return {
        ...state,
        loadingDelete: false
      }
    case DELETE_CHECKIN_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: null,
        message: null
      }
    case CLEAR_DATA_CHECKIN:
      return {
        ...state,
        dataCheckin: {},
        message: null
      }
    case GET_ALL_MEDICAL_INFO_REQUEST:
      return {
        ...state,
        loadingAllMedInfo: true,
        error: null
      }
    case GET_ALL_MEDICAL_INFO_SUCCESS:
      return {
        ...state,
        loadingAllMedInfo: false,
        dataAllMedicalInfo: action.payload,
        error: null
      }
    case GET_ALL_MEDICAL_INFO_FAIL:
      return {
        ...state,
        loadingAllMedInfo: false,
        dataAllMedicalInfo: [],
        error: action.payload
      }
    case GET_LIST_RAPT_CPPT_REQUEST:
      return { ...state, loadingRaptCppt: true, error: null }
    case GET_LIST_RAPT_CPPT_SUCCESS:
      return { ...state, loadingRaptCppt: false, raptCpptList: action.payload || [], error: null }
    case GET_LIST_RAPT_CPPT_FAIL:
      return { ...state, loadingRaptCppt: false, raptCpptList: [], error: action.payload }
    case GET_DETAIL_RAPT_CPPT_REQUEST:
      return { ...state, loadingRaptCpptDetail: true, raptCpptDetail: null, error: null }
    case GET_DETAIL_RAPT_CPPT_SUCCESS:
      return { ...state, loadingRaptCpptDetail: false, raptCpptDetail: action.payload, error: null }
    case GET_DETAIL_RAPT_CPPT_FAIL:
      return { ...state, loadingRaptCpptDetail: false, raptCpptDetail: null, error: action.payload }
    case POST_RAPT_CPPT_REQUEST:
      return { ...state, loadingPostRaptCppt: true, error: null }
    case POST_RAPT_CPPT_SUCCESS:
      return { ...state, loadingPostRaptCppt: false }
    case POST_RAPT_CPPT_FAIL:
      return { ...state, loadingPostRaptCppt: false, error: action.payload }
    case GET_MEDICAL_DATA_SUMMARIES_REQUEST:
      return { ...state, loadingMedicalDataSummaries: true, medicalDataSummaries: null, error: null }
    case GET_MEDICAL_DATA_SUMMARIES_SUCCESS:
      return { ...state, loadingMedicalDataSummaries: false, medicalDataSummaries: action.payload, error: null }
    case GET_MEDICAL_DATA_SUMMARIES_FAIL:
      return { ...state, loadingMedicalDataSummaries: false, medicalDataSummaries: null, error: action.payload }
    case PATCH_RAPT_CPPT_REQUEST:
      return { ...state, loadingPatchRaptCppt: true, error: null }
    case PATCH_RAPT_CPPT_SUCCESS:
      return { ...state, loadingPatchRaptCppt: false }
    case PATCH_RAPT_CPPT_FAIL:
      return { ...state, loadingPatchRaptCppt: false, error: action.payload }
    case DELETE_RAPT_CPPT_REQUEST:
      return { ...state, loadingDeleteRaptCppt: true, error: null }
    case DELETE_RAPT_CPPT_SUCCESS:
      return { ...state, loadingDeleteRaptCppt: false }
    case DELETE_RAPT_CPPT_FAIL:
      return { ...state, loadingDeleteRaptCppt: false, error: action.payload }
    case VERIFY_RAPT_CPPT_REQUEST:
      return { ...state, loadingVerifyRaptCppt: true, error: null }
    case VERIFY_RAPT_CPPT_SUCCESS:
      return { ...state, loadingVerifyRaptCppt: false }
    case VERIFY_RAPT_CPPT_FAIL:
      return { ...state, loadingVerifyRaptCppt: false, error: action.payload }
    case DUPLICATE_RAPT_CPPT_REQUEST:
      return { ...state, loadingDuplicateRaptCppt: true, error: null }
    case DUPLICATE_RAPT_CPPT_SUCCESS:
      return { ...state, loadingDuplicateRaptCppt: false }
    case DUPLICATE_RAPT_CPPT_FAIL:
      return { ...state, loadingDuplicateRaptCppt: false, error: action.payload }
    case GET_HISTORY_RAPT_CPPT_REQUEST:
      return { ...state, loadingRaptCpptHistories: true, error: null }
    case GET_HISTORY_RAPT_CPPT_SUCCESS:
      return { ...state, loadingRaptCpptHistories: false, raptCpptHistories: action.payload || [], error: null }
    case GET_HISTORY_RAPT_CPPT_FAIL:
      return { ...state, loadingRaptCpptHistories: false, raptCpptHistories: [], error: action.payload }
    case GET_MEDICAL_DIAGNOSIS_SUMMARIES_REQUEST:
      return { ...state, loadingMedicalDiagnosisSummaries: true, error: null }
    case GET_MEDICAL_DIAGNOSIS_SUMMARIES_SUCCESS:
      return { ...state, loadingMedicalDiagnosisSummaries: false, medicalDiagnosisSummaries: action.payload || [], error: null }
    case GET_MEDICAL_DIAGNOSIS_SUMMARIES_FAIL:
      return { ...state, loadingMedicalDiagnosisSummaries: false, medicalDiagnosisSummaries: [], error: action.payload }
    case 'DELETE_NOTE_REQUEST':
      return {
        ...state,
        loadingDeleteNote: true
      }
    case 'DELETE_NOTE_SUCCESS':
      return {
        ...state,
        loadingDeleteNote: false,
        dataCheckin: {
          ...state.dataCheckin,
          patient: {
            ...state.dataCheckin.patient,
            medicalInfoNote: ''
          }
        }
      }
    case 'DELETE_NOTE_FAIL':
      return {
        ...state,
        loadingDeleteNote: false,
        error: action.payload
      }
    case "GET_LIST_RESCRIPTION_REQUEST":
      return {
        ...state,
        loadingListRescription: true
      }
    case "GET_LIST_RESCRIPTION_SUCCESS":
      return {
        ...state,
        loadingListRescription: false,
        listRescription: action.payload,
        pageablePrescription: action.pageable,
        error: null
      }
    case "GET_LIST_RESCRIPTION_FAIL":
      return {
        ...state,
        loadingListRescription: false,
        error: action.payload,
        listRescription: []
      }
    case "GET_DETAIL_PRESCRIPTION_REQUEST":
      return {
        ...state,
        loadingDetailRescription: true
      }
    case "GET_DETAIL_PRESCRIPTION_SUCCESS":
      return {
        ...state,
        loadingDetailRescription: false
      }
    case "GET_DETAIL_PRESCRIPTION_FAIL":
      return {
        ...state,
        loadingDetailRescription: false
      }
    case GET_LIST_MEDICAL_PROCEDURE_REQUEST:
      return {
        ...state,
        loadingListMedicalProcedure: true
      }
    case GET_LIST_MEDICAL_PROCEDURE_SUCCESS:
      return {
        ...state,
        loadingListMedicalProcedure: false,
        listMedicalProcedure: action.payload,
        pageableMedicalProcedure: action.pageable,
        error: null
      }
    case GET_LIST_MEDICAL_PROCEDURE_FAIL:
      return {
        ...state,
        loadingListMedicalProcedure: false,
        error: action.payload,
        listMedicalProcedure: []
      }
    case GET_MEDICAL_DOCUMENT_SICK_LETTER_REQUEST:
      return {
        ...state,
        loadingMedicalDocumentSickLetter: true
      }
    case GET_MEDICAL_DOCUMENT_SICK_LETTER_SUCCESS:
      return {
        ...state,
        loadingMedicalDocumentSickLetter: false,
        medicalDocumentSickLetter: action.payload,
        error: null
      }
    case GET_MEDICAL_DOCUMENT_SICK_LETTER_FAIL:
      return {
        ...state,
        loadingMedicalDocumentSickLetter: false,
        error: action.payload,
        medicalDocumentSickLetter: null
      }
    case GET_LIST_MEDICAL_LETTER_REQUEST:
      return {
        ...state,
        loadingListMedicalLetter: true,
        listMedicalLetter: []
      }
    case GET_LIST_MEDICAL_LETTER_SUCCESS:
      return {
        ...state,
        loadingListMedicalLetter: false,
        listMedicalLetter: action.payload || [],
        pageableMedicalLetter: action.pageable || state.pageableMedicalLetter,
        error: null
      }
    case GET_LIST_MEDICAL_LETTER_FAIL:
      return {
        ...state,
        loadingListMedicalLetter: false,
        error: action.payload,
        listMedicalLetter: []
      }
    case GET_DETAIL_MEDICAL_LETTER_REQUEST:
      return {
        ...state,
        loadingDetailMedicalLetter: true,
        medicalLetterDetail: null
      }
    case GET_DETAIL_MEDICAL_LETTER_SUCCESS:
      return {
        ...state,
        loadingDetailMedicalLetter: false,
        medicalLetterDetail: action.payload,
        error: null
      }
    case GET_DETAIL_MEDICAL_LETTER_FAIL:
      return {
        ...state,
        loadingDetailMedicalLetter: false,
        error: action.payload,
        medicalLetterDetail: null
      }
    case GET_PATIENT_DATA_MEDICAL_LETTER_REQUEST:
      return {
        ...state,
        loadingDetailMedicalLetter: true,
        medicalLetterDetail: null
      }
    case GET_PATIENT_DATA_MEDICAL_LETTER_SUCCESS:
      return {
        ...state,
        loadingDetailMedicalLetter: false,
        medicalLetterDetail: action.payload,
        error: null
      }
    case GET_PATIENT_DATA_MEDICAL_LETTER_FAIL:
      return {
        ...state,
        loadingDetailMedicalLetter: false,
        error: action.payload
      }
    case SAVE_MEDICAL_LETTER_REQUEST:
      return {
        ...state,
        loadingMedicalLetterSubmit: true
      }
    case SAVE_MEDICAL_LETTER_SUCCESS:
      return {
        ...state,
        loadingMedicalLetterSubmit: false
      }
    case SAVE_MEDICAL_LETTER_FAIL:
      return {
        ...state,
        loadingMedicalLetterSubmit: false,
        error: action.payload
      }
    case DELETE_MEDICAL_LETTER_REQUEST:
      return {
        ...state,
        loadingMedicalLetterDelete: true
      }
    case DELETE_MEDICAL_LETTER_SUCCESS:
      return {
        ...state,
        loadingMedicalLetterDelete: false
      }
    case DELETE_MEDICAL_LETTER_FAIL:
      return {
        ...state,
        loadingMedicalLetterDelete: false,
        error: action.payload
      }

    case GET_LIST_MEDICAL_SUPPLIES_REQUEST:
      return {
        ...state,
        loadingListMedicalSupplies: true,
        listMedicalSupplies: []
      }
    case GET_LIST_MEDICAL_SUPPLIES_SUCCESS:
      return {
        ...state,
        loadingListMedicalSupplies: false,
        listMedicalSupplies: action.payload || [],
        pageableMedicalSupplies: action.pageable || state.pageableMedicalSupplies,
        error: null
      }
    case GET_LIST_MEDICAL_SUPPLIES_FAIL:
      return {
        ...state,
        loadingListMedicalSupplies: false,
        error: action.payload,
        listMedicalSupplies: []
      }
    case GET_DETAIL_MEDICAL_SUPPLIES_REQUEST:
      return { ...state, loadingDetailMedicalSupplies: true }
    case GET_DETAIL_MEDICAL_SUPPLIES_SUCCESS:
      return { ...state, loadingDetailMedicalSupplies: false }
    case GET_DETAIL_MEDICAL_SUPPLIES_FAIL:
      return { ...state, loadingDetailMedicalSupplies: false, error: action.payload }
    case POST_MEDICAL_SUPPLIES_REQUEST:
      return { ...state, loadingMedicalSuppliesSubmit: true }
    case POST_MEDICAL_SUPPLIES_SUCCESS:
      return { ...state, loadingMedicalSuppliesSubmit: false }
    case POST_MEDICAL_SUPPLIES_FAIL:
      return { ...state, loadingMedicalSuppliesSubmit: false, error: action.payload }
    case PATCH_MEDICAL_SUPPLIES_REQUEST:
      return { ...state, loadingMedicalSuppliesSubmit: true }
    case PATCH_MEDICAL_SUPPLIES_SUCCESS:
      return { ...state, loadingMedicalSuppliesSubmit: false }
    case PATCH_MEDICAL_SUPPLIES_FAIL:
      return { ...state, loadingMedicalSuppliesSubmit: false, error: action.payload }
    case DELETE_MEDICAL_SUPPLIES_REQUEST:
      return { ...state, loadingMedicalSuppliesDelete: true }
    case DELETE_MEDICAL_SUPPLIES_SUCCESS:
      return { ...state, loadingMedicalSuppliesDelete: false }
    case DELETE_MEDICAL_SUPPLIES_FAIL:
      return { ...state, loadingMedicalSuppliesDelete: false, error: action.payload }
    default:
      return state
  }
}

export default stationsReducer
